<template>
    <div v-if="viewEmployeeAwardsRegional" class="report-ve-awards">
      <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
      <transition name="fade">
        <div v-if="contentReady && contentLoadError === ''">
          <ContentHeader :name="$route.name"></ContentHeader>
          <div class="alert alert-info" style="padding-bottom: 30px;">
            <button type="button" class="btn btn-primary float-right showHideBtn" v-b-toggle.filterControls v-on:click="showHideFilters()" title="Show/Hide Filters" v-b-tooltip.hover>
              <span v-html="showHideFilterText"></span>
            </button>
            <div class="mr-2 float-right">
              Download current view as:
              <button type="button" class="btn btn-link p-0" v-on:click="exportToCSV()">
                <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as an Excel file"></i>
              </button>
            </div>
            <h4 class="alert-heading">Filtered Search</h4>
            <b-collapse visible id="filterControls" accordion="link-accordion" role="tabpanel">
              <hr>
              <div class="row">
                <div class="col-sm-4 mb-2">
                  <label>Nomination Category</label>
                  <select v-model="nominationCategorySelect" v-on:change="loadNominations()" class="form-control">
                    <!--option>-- All --</option-->
                    <option v-for="category in nominationCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3 mb-2">
                  <label for="nominatorFilter">From Date:</label>
                  <div class="input-group">
                    <!--input type="date" ref="fromDate" name="fromDate" id="fromDate" :value="fromDate" v-on:change="dateFilters()" /-->
                    <template>
                      <div style="position: relative;">
                        <label for="begin" style="position: absolute;top: 4px;left: 4px;width: 120px;z-index: 1;cursor: pointer;padding: 0px;background: white;">
                          {{ formattedFromDate }}
                        </label>
                        <input type="date" ref="datepicker"
                          :value="fromDate" :min="minDate" :max="maxDate"
                          @input="updateFromDate" @blur="hideDatepicker" v-on:change="dateFilters()"
                          style="position: absolute;top: 0px;left: 0px;width: 150px;padding:3px;display: block;border: 1px solid black;"
                        />
                      </div><BR/>
                    </template>
                  </div>
                </div>
                <div class="col-sm-3 mb-2">
                  <label for="nomineeFilter">To Date:</label>
                  <div class="input-group">
                    <template>
                      <div style="position: relative;">
                        <label
                          for="end"
                          style="position: absolute;top: 4px;left: 4px;width: 120px;z-index: 1;cursor: pointer;padding: 0px;background: white;">
                          {{ formattedToDate }}
                        </label>
                        <input
                          type="date"
                          ref="datepicker"
                          :value="toDate"
                          :min="minDate"
                          :max="maxDate"
                          @input="updateToDate"
                          @blur="hideDatepicker"
                          v-on:change="dateFilters()"
                          style="position: absolute;top: 0px;left: 0px;width: 150px;padding:3px;display: block;border: 1px solid black;"
                        />
                      </div><BR/>
                    </template>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
          <!--div class="row" id="nominations">
            <div class="col-sm-3">
              <div class="alert alert-primary text-center" role="alert">
                Nominations: {{nominationCounts.total}}
              </div>
            </div>
            <div class="col-sm-3">
              <div class="alert alert-warning text-center" role="alert">
                Pending: {{pending}}
              </div>
            </div>
            <div class="col-sm-3">
              <div class="alert alert-success text-center" role="alert">
                Accepted: {{approved}}
              </div>
            </div>
            <div class="col-sm-3">
              <div class="alert alert-danger text-center" role="alert">
                Rejected: {{rejected}}
              </div>
            </div>
          </div-->
          <NominationEmployeeReportEntries v-if="nominations.length > 0" :nominations="nominations"></NominationEmployeeReportEntries>
          <span v-if="nominations.length === 0">
            No nominations have been submitted
          </span>
          <div class="row">
            <div class="col-sm-6 mt-3">
              <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
            </div>
            <div class="col-sm-6 mt-3">
              <div class="items-per-page">
                <label for="itemsPerPage">Items per page: </label>
                <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="changeItemPerPage()" class="form-control">
                  <option :value="10">10</option>
                  <option :value="25">25</option>
                  <option :value="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <iframe id="iFramePdf" src="myPdfUrl.pdf" style="display:none;"></iframe>
    </div>
  </template>
  
  <script>
  import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
  import ExportToCSV from '@/helpers/ExportToCSV.js'
  import ContentHeader from '@/components/ContentHeader'
  import NominationEmployeeReportEntries from '@/components/NominationEmployeeReportEntries'
  import PreContentHeader from '@/components/PreContentHeader'
  import { mapGetters } from 'vuex'
  import {BCard, BTabs, BTab, BPagination, BCollapse} from 'bootstrap-vue'
  
  import 'bootstrap-vue'
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  
  export default {
    components: {
      PreContentHeader,
      ContentHeader,
      NominationEmployeeReportEntries,
      'b-card': BCard,
      'b-tabs': BTabs,
      'b-tab': BTab,
      'b-pagination': BPagination,
      'b-collapse': BCollapse
    },
    props: [
      'userDetails'
    ],
    data () {
      return {
        nominations: [],
        totalNominations: [],
        totalPaginationNominations: [],
        unfilteredNominations: [],
        contentReady: false,
        contentLoadError: '',
        graduatedNominationsCheck: false,
        nominationCategories: [],
        nominationCategorySelect: '-- All --',
        communityCategories: [],
        approverCategories: [
          { id: 'Sponsor', name: 'Sponsor' },
          { id: 'Manager', name: 'Manager' },
          { id: 'Exco2', name: 'Exco2' },
          { id: 'HRBP', name: 'HRBP' }
        ],
        nominationApproverSelect: '-- All --',
        communityCategorySelect: '-- All --',
        nominatorFilter: '',
        nominatorFilterButton: '+',
        nomineeFilter: '',
        nomineeFilterButton: '+',
        showHideFilterText: '<i class="fas fa-angle-up"></i>',
        currentPage: 1,
        totalPosts: 0,
        itemsPerPage: 10,
        toDate: '',
        fromDate: '',
        userType: 'HRBP',
        approved: 0,
        rejected: 0,
        pending: 0,
        showDatepickerFlag: true,
        minDate: '',
        maxDate: '',
        lastRecord: 0
      }
    },
    computed: {
      ...mapGetters([
        'getProfileDetails',
        'viewEmployeeAwardsRegional'
      ]),
      nominationCounts: function () {
        return {
          total: this.totalPosts,
          pending: this.nominations.filter(x => x.nomination_approve_decline && x.nomination_approve_decline[0] === 'Pending').length,
          accepted: this.nominations.filter(x => x.nomination_approve_decline && x.nomination_approve_decline[0] === 'Accepted').length,
          declined: this.nominations.filter(x => x.nomination_approve_decline && x.nomination_approve_decline[0] === 'Declined').length
        }
      },
      formattedFromDate() {
        console.log(' formattedDate ', this.fromDate)
        if (!this.fromDate) return ''
        const date = new Date(this.fromDate)
        const day = ('0' + date.getDate()).slice(-2)
        const month = ('0' + (date.getMonth() + 1)).slice(-2)
        const year = date.getFullYear()
        console.log(' formattedDate ', year+'-'+month+'-'+day)
        return this.fromDate
      },
      formattedToDate() {
        console.log(' formattedDate ', this.toDate)
        if (!this.toDate) return ''
        const date = new Date(this.toDate)
        const day = ('0' + date.getDate()).slice(-2)
        const month = ('0' + (date.getMonth() + 1)).slice(-2)
        const year = date.getFullYear()
        console.log(' formattedDate ', year+'-'+month+'-'+day)
        return this.toDate
      }
    },
    created () {
      console.log('created viewEmployeeAwardsRegional ', this.viewEmployeeAwardsRegional)  
      document.title = this.$route.name + ' - ThinkTank'
      var self = this
      var usernameOptions = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(usernameOptions, 'users/me?context=edit')
      .then(function (userResponse) {
          self.userDetails = userResponse.data
          console.log('profile UD-> ', self.userDetails)
          console.log(' self.userDetails ', self.userDetails)

        WordpressRestAPI.getViewContent('nomination_event_category?per_page=100')
        .then(response => {
          self.nominationCategories = response.data.filter(x => x.id == 141)
          console.log(' self.nominationCategories ', self.nominationCategories)
          self.nominationCategorySelect = self.nominationCategories[0].id
          console.log('created nominationCategories ', self.nominationCategories, self.nominationCategories[0], self.nominationCategorySelect)
          const today = new Date()
          const year = today.getFullYear()
          const month = today.getMonth() + 1 // Adding 1 since January is 0
          const day = today.getDate()
          const financialYear = month < 4 ? year - 1 : year
          const formattedDate = `${financialYear}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
          const financialYearStart = month < 4 ? year - 1 : year
          const minDate = `${financialYearStart}-04-01`
          const maxDate = `${financialYearStart + 1}-03-31`
          
          self.toDate = maxDate
          self.fromDate = minDate
                  
          self.minDate = minDate
          self.maxDate = maxDate
  
          console.log('Formatted From Date:', self.fromDate)
          self.loadNominations()
        })
        .catch(e => {
          console.error(e)
        })
        WordpressRestAPI.getViewContent('community_categories?per_page=100')
        .then(response => {
          self.communityCategories = response.data
        })
        .catch(e => {
          console.error(e)
        })
      })
      .catch(e => {
          console.error(e)
      })
    },
    methods: {
      showDatepicker() {
        this.showDatepickerFlag = true;
        this.$nextTick(() => {
          this.$refs.datepicker.focus();
        });
      },
      updateFromDate(event) {
        this.fromDate = event.target.value;
        this.$emit('change', this.fromDate);
        this.showDatepicker = false;
      },
      updateToDate(event) {
        this.toDate = event.target.value;
        this.$emit('change', this.toDate);
        this.showDatepicker = false;
      },
      hideDatepicker() {
        setTimeout(() => {
          this.showDatepicker = false;
        }, 200000); // delay to allow date selection before hiding
      },        
      getNominationCounts: function () {
        this.approved = 0
        this.rejected = 0
        this.pending = 0    
        console.log('254 getNominationCounts ', this.nominations)
        this.nominations.forEach(item => {
          console.log('getNominationCounts item ', item, item.teamnominationworkflow)
          if (item.teamnominationworkflow[0][2].project_sponsor_status === 'Approve') {
            this.approved++
          } else if (item.teamnominationworkflow[0][2].project_sponsor_status === 'Reject') {
            this.rejected++
          } else if (item.teamnominationworkflow[0][2].project_sponsor_status === '') {
            this.pending++
          }
        });
        console.log(' getNominationCounts teamItem ', this.approved, this.pending)
      },  
      exportToPDF: function () {
        window.print()
      },
      validateDates: function() {
        if (this.$refs.toDate)
          this.toDate = this.$refs.toDate.value
  
        if (this.$refs.fromDate)
          this.fromDate = this.$refs.fromDate.value
  
        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth() + 1 // Adding 1 since January is 0
        const financialYearStart = month < 4 ? year - 1 : year
        const minDate = new Date(`${financialYearStart}-04-01`)
        const maxDate = new Date(`${financialYearStart + 1}-03-31`)
  
        const fromDate = new Date(this.fromDate)
  
        console.log('validateDates ', this.fromDate, ', 2024-04-01')
        if (fromDate < minDate || fromDate > maxDate) {
          console.log('validateDates greater than 319')
          this.fromDate = `${financialYearStart}-04-01`
          alert('Please select date in current Financial Year')
          return false
        }
        const toDate = new Date(this.toDate)
        if (toDate < minDate || toDate > maxDate) {
          console.log('validateDates greater than 326')
          this.toDate = `${financialYearStart + 1}-03-31`
          alert('Please select date in current Financial Year to Date')
          return false
        }
  
        if (toDate < fromDate) {
          alert('To Date should be greater than From Date')
          this.fromDate = `${financialYearStart}-04-01`
          this.toDate =   `${financialYearStart + 1}-03-31`
          return false
        }
  
        if ( this.toDate !== '' && this.fromDate !== '') {
          console.log('nomination date-> ', this.nominations.date)
          console.log('nomination parse date-> ', Date.parse(this.nominations.date))
          return '&after=' + this.fromDate + ' 00:00:00&before=' + this.toDate + ' 23:59:59'
        }
        return false
      },
      exportContentData: function (data) {
        var chunks = data[0].split(' @#$% ')
        var header = ''
        var value = ''
        var exportData = []
        chunks.map(function (val, index) {
          if (val.indexOf('<h>') > -1) {
            header = val.replace(/<h>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';')
          }
          if (val.indexOf('<c>') > -1) {
            value = val.replace(/<c>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';').replace(/ /g, ' ').replace(/ /g, ' ').replace(/ /g, ' ')
            exportData[header] = value
          }
        })
        return exportData
      },    
      getSingleNomineeInfo: function (x) {
        var nomineesInfo = { 'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'department': [], 'country': [], 'gom': [], 'projectSponsor': '', 'projectSponsorApproved': '', 'projectSponsorDeclinedReason': '', 'projectSponsorDate': '' }
        nomineesInfo.nomineeName = x.nominee_name[0]
        nomineesInfo.nomineeEmployeNumber = x.nominee_employeeNumber[0]
        nomineesInfo.nomineeEmail = x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g, '.')
        nomineesInfo.nomineeCompany = (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : ''
        nomineesInfo.businessUnit = ' '
        nomineesInfo.department = ' '      
        nomineesInfo.country = ' '
        nomineesInfo.gom = ' '
        if ('employeehierarchy' in x.nominee_slug && x.nominee_slug.employeehierarchy) {
          nomineesInfo.nomineeEmail = x.nominee_slug[1]
          nomineesInfo.businessUnit = 'businessunit' in x.nominee_slug.employeehierarchy ? x.nominee_slug.employeehierarchy.businessunit[0] : ''
          nomineesInfo.department =  (x.nominee_slug.employeehierarchy &&  x.nominee_slug.employeehierarchy['departmentname'] && 
     Array.isArray(x.nominee_slug.employeehierarchy['departmentname']) &&
     x.nominee_slug.employeehierarchy['departmentname'][0]) ? x.nominee_slug.employeehierarchy['departmentname'][0] : ''
          nomineesInfo.country = x.nominee_slug.employeehierarchy.country[0]
          nomineesInfo.gom = x.nominee_slug.employeehierarchy.gom[0]
          if ('employeenumber' in x.nominee_slug.employeehierarchy)
            nomineesInfo.nomineeEmployeNumber = x.nominee_slug.employeehierarchy.employeenumber[0]
        }
        return nomineesInfo
      },
      getNomineeInfo: function (nomineesInfo, x, i, count) {
        nomineesInfo.nomineeName += (count - 1 === i) ? x.member_name : x.member_name + ' $&$ '
        var nomineeEmployeNumber = (count - 1 === i) ? x.member_employee_number : x.member_employee_number + ' $&$ '
        nomineesInfo.nomineeCompany += (count - 1 === i) ? x.member_company.replace(/,/g, ' ') : x.member_company.replace(/,/g, ' ') + ' $&$ '
        var employeeNumberflag = true
        if (x.member_email.indexOf('@') > -1 && 'businessunit' in x.employeehierarchy) {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_email : x.member_email + ' $&$ '
          nomineesInfo.businessUnit += (count - 1 === i) ? x.employeehierarchy.businessunit[0] : x.employeehierarchy.businessunit[0] + ' $&$ '
          if (x.employeehierarchy && 'departmentname' in x.employeehierarchy && Array.isArray(x.employeehierarchy['departmentname'])) {
            // Safely handle departmentname[0] being null or undefined
            let departmentValue = x.employeehierarchy['departmentname'][0] !== null && 
                                  x.employeehierarchy['departmentname'][0] !== undefined 
                                  ? x.employeehierarchy['departmentname'][0] 
                                  : '';
  
            // Concatenate based on the count logic
            nomineesInfo.department += 
              (count - 1 === i) 
                ? departmentValue
                : departmentValue + ' $&$ ';
          } else {
            // Handle case where departmentname is not present or not an array
            let departmentValue = ''
            nomineesInfo.department += (count - 1 === i) ? departmentValue : departmentValue + ' $&$ '
          }
          nomineesInfo.country += (count - 1 === i) ? x.employeehierarchy.country[0] : x.employeehierarchy.country[0] + ' $&$ '
          nomineesInfo.gom += (count - 1 === i) ? x.employeehierarchy.gom[0] : x.employeehierarchy.gom[0] + ' $&$ '
          if ('employeenumber' in x.employeehierarchy) {
            employeeNumberflag = false
            nomineesInfo.nomineeEmployeNumber += (count - 1 === i) ? x.employeehierarchy.employeenumber[0] : x.employeehierarchy.employeenumber[0] + ' $&$ '
          }
        }
        else {
          nomineesInfo.gom = nomineesInfo.nomineeCompany
          nomineesInfo.businessUnit += (count - 1 === i) ? ' '  : '  $&$ '
          nomineesInfo.department += (count - 1 === i) ? ' '  : '  $&$ '
          nomineesInfo.country += (count - 1 === i) ? ' '  : '  $&$ '
          var emailCreator = ''
          var emailCreatorName = ''
          emailCreator = x.member_name.replace(/ /g, '.') + '@'
          emailCreatorName = x.member_name.toLowerCase().replace(/ /g, '-')
          emailCreator = x.member_slug.replace(emailCreatorName, emailCreator).replace(/-/g, '.')
          if (x.member_company.toLowerCase().indexOf('multichoice') > -1) {
            nomineesInfo.nomineeEmail += (count - 1 === i) ? emailCreator : emailCreator + ' $&$ '
          } else {
            nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') : x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') + ' $&$ '
          }
        }
        if (employeeNumberflag == true)
          nomineesInfo.nomineeEmployeNumber += nomineeEmployeNumber
        return nomineesInfo
      },
      exportTeamData: function (teamDetails) {
        var self = this
        var nomineesInfo = {'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'department': [], 'country': [], 'gom': []}
        var count = teamDetails.length
        if (count > 1) {
          teamDetails.map(function (x, i) {
            nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
          })
        } else {
          teamDetails[0].map(function (x, i) {
            nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
          })
        }
        return nomineesInfo
      },
      getDateTime: function (val, needle, index) {
        if(val !== undefined && val !== null && val !== "" && val !== "NA") {
          return val.split(needle)[index]
        } else {
          return ''
        }
      },
      exportFullReportToCSV: function () {
        // Call the function to fetch nominations
        this.totalLoadNominations()
        .then(() => {
          console.log('Nominations fetching complete.');
          // Continue with further processing once all records are fetched
          var self = this
          // Map fields of totalNominations array that will be converted to CSV
          const items = this.totalNominations.map(function (x) {
            var splitData = {}
            var nomineesDetails = {}
            if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
              do {
                if (x.teamnominationworkflow[0].length === 1) {
                  console.log('moved ->  ')
                  x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
                }
              } while (x.teamnominationworkflow[0].length === 1)
            }
            if (x.nominationdata.length) {
              splitData = self.exportContentData(x.nominationdata)
            }
            if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
              nomineesDetails = self.exportTeamData(x.nominationteam[0])
              if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
                nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
                nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
                nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
                nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
              }
            } else {
              nomineesDetails = self.getSingleNomineeInfo(x)
            }
            const temp = Object.assign({}, {
              Nominator_Name: x._embedded.author[0].name,
              Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
              Nominee_Name: nomineesDetails.nomineeName,
              Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
              Nominee_Email: nomineesDetails.nomineeEmail,
              GOM: nomineesDetails.gom,
              BU: nomineesDetails.businessUnit,
              Department: nomineesDetails.department,            
              Country: nomineesDetails.country,
              Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
              Nominee_Status: x.nomination_approve_decline[0],
              Date_Of_Nomination: x.date.split('T')[0],
              Time_Of_Nomination: x.date.split('T')[1],
              selection_period: (x.selectionperiod && x.selectionperiod.length && x.selectionperiod[0] !== null && x.selectionperiod[0] !== undefined) ? (x.selectionperiod[0]) : '',
              Project_Sponsor: nomineesDetails.projectSponsor,
              Project_Sponsor_Approved: nomineesDetails.projectSponsorApproved,
              Project_Sponsor_Reason: nomineesDetails.projectSponsorDeclinedReason,
              Project_Sponsor_Date: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 0),
              Project_Sponsor_Time: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 1),
              Line_Manager: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_email'] : '',
              Line_Manager_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_status'] : '',
              Line_Manager_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_comment'] : '',
              Line_Manager_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 0) : '',
              Line_Manager_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 1) : '',
              Exco2: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_email'] : '',
              Exco2_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_status'] : '',
              Exco2_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_comment'] : '',
              Exco2_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 0) : '',
              Exco2_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 1) : '',
              HRBP: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_email'] : '',
              HRBP_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_status'] : '',
              HRBP_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_comment'] : '',
              HRBP_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 0) : '',
              HRBP_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 1) : ''
            }, splitData)
            return temp
          })
  
          var keysOnly = []
          for (var k = 0; k < items.length; k++) {
            keysOnly = keysOnly.concat(Object.keys(items[k]))
          }
  
          let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)
  
          for (var i = 0; i < items.length; i++) {
            for (var j = 0; j < csvKeys.length; j++) {
              if (items[i][csvKeys[j]]) {
                items[i][csvKeys[j]] = items[i][csvKeys[j]]
              } else {
                items[i][csvKeys[j]] = ''
              }
            }
          }
  
          // Convert to JSON and then create CSV file for download
          let cloneItems = []
          let dupItems = JSON.parse(JSON.stringify(items))
          var iIndex = 0
          for (var u = 0; u < dupItems.length; u++) {
            if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
              var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
              var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
              var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
              var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
              for (var w = 0; w < nomineeNameCount.length; w++) {
                cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
                cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
                cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
                cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
                cloneItems[iIndex].GOM = nomineeCompanyCount[w]
                iIndex++
              }
            } else {
              cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
              iIndex++
            }
          }
          console.log('items', items)
          ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle the error if needed
        });
      },
      exportToCSV: function () {
        var self = this
        if (self.fromDate && self.toDate && self.nominations.length > 0) {
          // Map fields of nominations array that will be converted to CSV
          const items = this.nominations.map(function (x) {
            console.log('exportToCSV x downgrade_status', x.id, x.downgrade_status)
            var splitData = {}
            var nomineesDetails = {}
            if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
              do {
                if (x.teamnominationworkflow[0].length === 1) {
                  console.log('moved ->  ')
                  x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
                }
              } while (x.teamnominationworkflow[0].length === 1)
            }
            if (x.nominationdata.length) {
              splitData = self.exportContentData(x.nominationdata)
            }
            if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
              nomineesDetails = self.exportTeamData(x.nominationteam[0])
            } else {
              nomineesDetails = self.getSingleNomineeInfo(x)
            }
            console.log('team length ', x.teamnominationworkflow[0].length, x.teamnominationworkflow[0])
            for (let index = 0; index < x.teamnominationworkflow[0].length; index++) {
                console.log(' x489 ', x.teamnominationworkflow[0][index].project_sponsor_status, x.teamnominationworkflow[0][index].project_sponsor_name)
                const result =   x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' || 
              x.teamnominationworkflow[0][index].project_sponsor_status === 'Approved' ? 'Approved' :
              x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' || 
              x.teamnominationworkflow[0][index].project_sponsor_status === 'Rejected' ? 'Rejected' : 
              'Pending'
                x.teamnominationworkflow[0][index].project_sponsor_status = result
              console.log(' x489 577 ', result, x.teamnominationworkflow[0][index].project_sponsor_status)
            }
            const temp = Object.assign({}, {
              Nominator_Name: x._embedded.author[0].name,
              Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
              Nominee_Name: nomineesDetails.nomineeName,
              Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
              Nominee_Email: nomineesDetails.nomineeEmail,
              GOM: nomineesDetails.gom,
              BU: nomineesDetails.businessUnit,
              Department: nomineesDetails.department,            
              Country: nomineesDetails.country,
              Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
              Nominee_Status: x.nomination_approve_decline[0],
              Date_Of_Nomination: x.date.split('T')[0],
              Time_Of_Nomination: x.date.split('T')[1],
              selection_period: (x.selectionperiod && x.selectionperiod.length && x.selectionperiod[0] !== null && x.selectionperiod[0] !== undefined) ? (x.selectionperiod[0]) : '',
              Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
              Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
              Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
              Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
              Exco2_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
              EmployeeAwardCountry: x.EmployeeAwardCountry[0],
              EmployeeAwardRegion: x.EmployeeAwardRegion[0],
            }, splitData)
            return temp
          })

          var keysOnly = []
          for (var k = 0; k < items.length; k++) {
            //console.log(' k ', k, items[k])
            keysOnly = keysOnly.concat(Object.keys(items[k]))
          }
  
          let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)
          console.log(' csvKeys ', csvKeys)
          for(var i = 0; i < csvKeys.length; i++) {
            if (csvKeys[i] === 'Why are you nominating this person?' || csvKeys[i] === 'Why are you nominating this team?') {
              console.log(' csvKeys[i] ', i, csvKeys[i])
              //csvKeys[i] = 'Nominator Motivation Reason'
            }
          }
          for (var i = 0; i < items.length; i++) {
            for (var j = 0; j < csvKeys.length; j++) {
              if (items[i][csvKeys[j]]) {
                items[i][csvKeys[j]] = items[i][csvKeys[j]]
              } else {
                items[i][csvKeys[j]] = ''
              }
            }
          }
  
          // Convert to JSON and then create CSV file for download
          let cloneItems = []
          let dupItems = JSON.parse(JSON.stringify(items))
          var iIndex = 0
          for (var u = 0; u < dupItems.length; u++) {
            if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
              var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
              var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
              var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
              var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
              for (var w = 0; w < nomineeNameCount.length; w++) {
                cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
                cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
                cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
                cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
                cloneItems[iIndex].GOM = nomineeCompanyCount[w]
                iIndex++
              }
            } else {
              cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
              iIndex++
            }
          }
          console.log('items', items)
          ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
          // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
        } else {
          if (!self.fromDate || !self.toDate) {
              alert('Please select date range')
          }  
          else if (self.nominations.length === 0)  {
              alert("No record to download report in given date range.")      
          }
        }
      },
      showHideFilters: function () {
        if (this.showHideFilterText === '<i class="fas fa-angle-up"></i>') {
          this.showHideFilterText = '<i class="fas fa-angle-down"></i>'
        } else {
          this.showHideFilterText = '<i class="fas fa-angle-up"></i>'
        }
      },
      filterByGraduatedNominations: function () {
        if (this.graduatedNominationsCheck) {
          this.nominationCategorySelect = 45
        } else {
          this.nominationCategorySelect = '-- All --'
        }
        this.loadNominations()
      },
      totalLoadNominations: async function () {
        const perPageVal = 'custom_per_page=10'
        let userEmails = []
        if (typeof this.userDetails.email !== 'undefined' && typeof this.userDetails.email !== 'undefined' ) {
          userEmails = [this.userDetails.email.toLowerCase(), this.userDetails.username.toLowerCase()]
        } else if (typeof this.userDetails.email !== 'undefined') {
          userEmails = [this.userDetails.email.toLowerCase(), this.userDetails.email.toLowerCase()]
        } else if (typeof this.userDetails.username !== 'undefined') {
          userEmails = [this.userDetails.username.toLowerCase(), this.userDetails.username.toLowerCase()]
        }
  
        let offset = 0
        while (true) {
          try {
            const response = await WordpressRestAPI.getCustomViewContent('getNomination/v1/getuserTotalnominationForRewardGroup?email=' + userEmails.join(',') + '&type=' + this.userType + '&page=' + offset + '&' + perPageVal);
            console.log('review list-> ', response.data);          
            if (response.data !== false) {
              this.totalNominations.push(...response.data)
              this.totalPaginationNominations.push(...response.data)
              console.log('getNomination/v1/getuserTotalnominationForRewardGroup?email=' + userEmails.join(',') + '&type=' + this.userType + '&page=' + this.currentPage + '&' + perPageVal)
              console.log('Total Nominations:', this.totalNominations.length,' response.data.length ', response.data.length);
              if (response.data.length < 10) {
                console.log('inside break')
                break;
              }
              offset++
            }
            this.contentReady = true;
          } catch (e) {
            this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.';
            console.error(e);
            this.contentReady = true;
            break; // Exit the loop on error
          }
        }
      },
      dateFilters: function () {
        var status = this.validateDates()
        console.log(' status ', status)
        if (status) {
          console.log('date filter  true called', this.fromDate , this.toDate)
          if (this.fromDate && this.toDate) {
            console.log('load nomination called')
              this.loadNominations()
          }
        }
      },
      changeItemPerPage: function () {
        this.currentPage = 0
        this.loadNominations()
      },
      generateSearchQuery: function () {
        let userEmails = []
        console.log(' 642 generateSearchQuery ', this.userDetails)
        if (typeof this.userDetails.email !== 'undefined' && typeof this.userDetails.username !== 'undefined' ) {
          userEmails = [this.userDetails.email.toLowerCase(), this.userDetails.username.toLowerCase()]
        } else if (typeof this.userDetails.email !== 'undefined') {
          userEmails = [this.userDetails.email.toLowerCase(), this.userDetails.email.toLowerCase()]
        } else if (typeof this.userDetails.username !== 'undefined') {
          userEmails = [this.userDetails.username.toLowerCase(), this.userDetails.username.toLowerCase()]
        }
        let offset = Math.max(this.currentPage - 1, 0) * this.itemsPerPage
        console.log(' offset ', offset, this.currentPage, Math.max(this.currentPage - 1,0))
        let string = '?email=' + userEmails+'&type='+this.userType+'&perPage='+this.itemsPerPage+'&offset='+offset
        if (this.nominationCategorySelect === '-- All --'){
          string = string+'&nomination_categories=141'
        } else {
          string = string+'&nomination_categories=' + this.nominationCategorySelect
        }
        if (typeof this.nominationApproverSelect !== 'undefined'){
          string = string+'&approver_categories=' + this.nominationApproverSelect
        }
        if (this.fromDate && this.toDate) {
          console.log(' string  '+string)
          string = string+'&from='+this.fromDate+'&to='+this.toDate
        }
        string = string+'&lastRecord='+this.lastRecord
        console.log('string ', string)
        return string
      },
      loadNominations: function () {
        this.contentReady = false
        console.log(' this.userDetails ', this.userDetails, this.itemsPerPage, this.nominations.length)
        if (this.userDetails.email !== undefined) {
          console.log('before calling userEmails')
          WordpressRestAPI.getCustomViewContent('getNomination/v1/getusernominationForEmployeeAwardRegional'+this.generateSearchQuery())
          .then(response => {
            console.log('review list-> ', response.data)
            if (response.data !== false) {
              console.log(' response.data ', response.data)
              this.nominations = response.data['data']
              //this.totalPageNominations = response.data['data']
              this.totalPosts = response.data['total_post']
            } else {
              this.nominations= []
              this.totalPosts = 0
            }
            this.getNominationCounts()
            this.contentReady = true;
          })
          .catch(e => {
            this.contentReady = true
            this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
            console.error(e)
          })
        }
      },
      filterByNominee: function () {
        this.nominations = this.unfilteredNominations
        var self = this
        if (this.nomineeFilter !== '' && this.nomineeFilterButton === '+') {
          this.nominations = this.nominations.filter(x => x.nominee_name[0].toLowerCase().indexOf(self.nomineeFilter.toLowerCase()) > -1)
        }
        if (this.nomineeFilterButton === '+') {
          this.nomineeFilterButton = 'x'
        } else {
          this.nomineeFilterButton = '+'
          this.nomineeFilter = ''
        }
      },
      filterByNominator: function () {
        this.nominations = this.unfilteredNominations
        if (this.nominatorFilter !== '' && this.nominatorFilterButton === '+') {
          this.nominations = this.nominations.filter(x => x._embedded.author[0].name.toLowerCase().indexOf(this.nominatorFilter.toLowerCase()) > -1)
        }
        if (this.nominatorFilterButton === '+') {
          this.nominatorFilterButton = 'x'
        } else {
          this.nominatorFilterButton = '+'
          this.nominatorFilter = ''
        }
      },
      filterByStatus: function (status) {
        this.nominations = this.unfilteredNominations
        if (status !== 'All') {
          this.nominations = this.nominations.filter(x => x.nomination_approve_decline[0] === status)
        }
      }
    },
    watch: {
      viewEmployeeAwardsRegional(newValue) {
        console.log('viewEmployeeAwardsRegional changed to:', newValue);
      },  
      'currentPage' (newDetails, oldDetails) {
        console.log(' newDetails ', newDetails)
        console.log(' oldDetails ', oldDetails)
        this.loadNominations()
      }
    }
  }
  </script>
  
  <style lang="less">
    .showHideBtn {
      padding: 4px 8px;
    }
  </style>


// WEBPACK FOOTER //
// src/components/routes/VEAwardForEmployeeNominationRegional.vue